export const tagTypes = {
  publicCalendar: "publicCalender",
  appointment: "appointment",
  otp: "otp",
  otEnquiry: "otEnquiry",
};

export const tagTypesList = [tagTypes.publicCalendar, tagTypes.appointment, tagTypes.otEnquiry];
